interface ProShareIconProps {
    color?: string;
    className?: string;
}

function ProShareIcon({ color = 'currentColor', className = null }: ProShareIconProps) {
    return (
        <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M10.7739 14.0836C10.7739 14.7179 10.2634 15.2334 9.63538 15.2334H1.89748C1.26941 15.2334 0.75899 14.7179 0.75899 14.0836V1.9164C0.75899 1.28207 1.26941 0.766559 1.89748 0.766559H9.63538C10.2634 0.766559 10.7739 1.28207 10.7739 1.9164V5.89292H11.5329V1.9164C11.5329 0.860462 10.6809 0 9.63538 0H1.89748C0.851967 0 0 0.860462 0 1.9164V14.0836C0 15.1395 0.851967 16 1.89748 16H9.63538C10.6809 16 11.5329 15.1395 11.5329 14.0836V10.109H10.7739V14.0836Z"
                fill={color}
            />
            <path
                d="M16.7223 8.35162L17.0866 8.0105L16.7223 7.64064V7.61572H16.6976L13.8817 4.77179L13.3448 5.31413L15.6236 7.61572H10.7737V8.38228H15.5724L13.3448 10.4712L13.8609 11.0327L16.69 8.38228H16.7223V8.35162Z"
                fill={color}
            />
            <path
                d="M9.53661 6.91055H6.60311L8.28048 2.55841L1.99414 9.08758H4.92764L3.25217 13.4397L9.53661 6.91055Z"
                fill={color}
            />
        </svg>
    );
}

export default ProShareIcon;
